var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "imports-form-card" }, [
    _c("span", { staticClass: "card-title" }, [
      _vm._v(_vm._s(_vm.$tc("ImportNoun", 1) + " " + _vm.$tc("Layer", 2)))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "imports-form-container" },
      _vm._l(_vm.fields, function(field, index) {
        return _c(
          "div",
          {
            key: field.label,
            staticClass: "card-info-item-container",
            style: [{ width: "100%", overflow: "visible" }]
          },
          [
            _c(
              "div",
              { staticClass: "card-info-item" },
              [
                field.inputType !== "file"
                  ? _c("input-field", {
                      key: field.varName,
                      attrs: {
                        "input-type": field.inputType,
                        value: field.value,
                        label: field.label,
                        "input-disabled": field.disabled,
                        "select-options-list": field.options,
                        disableBranchNodes: field.disableBranchNodes,
                        "checkbox-options": field.checkboxOptions,
                        min: field.min,
                        max: field.max,
                        step: field.step,
                        size: "large",
                        clearable: field.clearable,
                        required: field.required,
                        inputFieldContainerStyling: { padding: "0" },
                        "radio-options": field.radioOptions,
                        placeholder: field.placeholder,
                        "input-style": _vm.inputStyle
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateField($event, field)
                        }
                      }
                    })
                  : _c("InputField", {
                      key: index,
                      attrs: {
                        inputStyle: {
                          color: "#767676 !important"
                        },
                        inputFieldContainerStyling:
                          _vm.uploadFileInputContainersStyle,
                        "input-type": field.inputType,
                        size: "large",
                        "file-types": _vm.acceptedFileTypes,
                        value: field.value,
                        required: field.required,
                        "input-disabled": field.disabled
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateField($event, field)
                        }
                      }
                    })
              ],
              1
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-buttons" },
      [
        _c("custom-button", {
          attrs: {
            label: _vm.submittButtonLabel,
            "button-color": "var(--app-primary-base)",
            "label-color": "#FFF",
            "button-styling": _vm.actionButtonsStylingSave,
            disabled: _vm.requiredFieldsFilled,
            "is-loading": _vm.loading
          },
          on: { buttonClick: _vm.submitForm }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ac72fde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac72fde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Imports/ImportsForm.vue
// module id = null
// module chunks = 